import { render, staticRenderFns } from "./ListPurchasesPaymentPage.vue?vue&type=template&id=23662528"
import script from "./ListPurchasesPaymentPage.vue?vue&type=script&lang=js"
export * from "./ListPurchasesPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports